var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "720", persistent: _vm.saving },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "mb-4",
                      attrs: {
                        color: "primary",
                        outlined: "",
                        "data-test": "steffi-open-offline-trial",
                      },
                    },
                    "v-btn",
                    attrs,
                    false
                  ),
                  on
                ),
                [_vm._v("\n            Offline-Testphase erfassen\n        ")]
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.open,
        callback: function ($$v) {
          _vm.open = $$v
        },
        expression: "open",
      },
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c("v-card-title", [_vm._v("Offline-Testphase erfassen")]),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c("p", [
                _vm._v(
                  "\n                Wählen Sie die Apotheke aus, deren Testphase außerhalb der Plattform stattfindet.\n                Die Kennzeichnung blendet die FPP-Testphase aus und verhindert weitere FPP-Testbuchungen.\n                Eine angefragte oder laufende FPP-Testphase wird beendet. Kostenpflichtige Buchungen bleiben unverändert.\n            "
                ),
              ]),
              _vm._v(" "),
              _vm.error
                ? _c(
                    "v-alert",
                    { attrs: { type: "error", outlined: "", dense: "" } },
                    [_vm._v(_vm._s(_vm.error))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: {
                  label: "Apotheke suchen",
                  maxlength: "100",
                  hint: "Mindestens 2 Zeichen: Name, Kundennummer, Postleitzahl oder Ort",
                  "persistent-hint": "",
                  disabled: _vm.loading || _vm.saving,
                  "data-test": "steffi-offline-search",
                },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.findPharmacies.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              }),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    outlined: "",
                    disabled:
                      _vm.search.trim().length < 2 || _vm.loading || _vm.saving,
                    loading: _vm.loading,
                    "data-test": "steffi-offline-search-submit",
                  },
                  on: { click: _vm.findPharmacies },
                },
                [_vm._v("Suchen")]
              ),
              _vm._v(" "),
              _vm.items
                ? [
                    !_vm.items.length && !_vm.loading
                      ? _c("p", { staticClass: "mt-4" }, [
                          _vm._v("Keine Apotheken gefunden."),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "v-radio-group",
                      {
                        attrs: { disabled: _vm.loading || _vm.saving },
                        model: {
                          value: _vm.selected,
                          callback: function ($$v) {
                            _vm.selected = $$v
                          },
                          expression: "selected",
                        },
                      },
                      _vm._l(_vm.items, function (item) {
                        return _c("v-radio", {
                          key: item.pharmacy_id,
                          attrs: {
                            value: item,
                            disabled: item.steffi_offline_trial,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c("div", [
                                      _c("strong", [_vm._v(_vm._s(item.name))]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            item.customer_id || item.pharmacy_id
                                          ) +
                                            " · " +
                                            _vm._s(item.zip) +
                                            " " +
                                            _vm._s(item.city)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      item.steffi_offline_trial
                                        ? _c("span", [
                                            _vm._v(
                                              "Offline-Testphase bereits erfasst"
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _vm.items.length === 20
                      ? _c("p", { staticClass: "text-caption" }, [
                          _vm._v(
                            "Es werden höchstens 20 Treffer angezeigt. Bitte grenzen Sie die Suche bei Bedarf ein."
                          ),
                        ])
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { text: "", disabled: _vm.saving },
                  on: {
                    click: function ($event) {
                      _vm.open = false
                    },
                  },
                },
                [_vm._v("Schließen")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    disabled:
                      !_vm.selected ||
                      _vm.selected.steffi_offline_trial ||
                      _vm.loading ||
                      _vm.saving,
                    loading: _vm.saving,
                    "data-test": "steffi-offline-save",
                  },
                  on: { click: _vm.save },
                },
                [_vm._v("Offline-Testphase erfassen")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }